// 在index中统一导出reducer

import { reducer } from './reducer';

export {
  reducer,
};
